import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { QuickTestimonials } from './components/QuickTestimonials';
import { PainPoints } from './components/PainPoints';
import { SystemIntro } from './components/SystemIntro';
import { TomosGrid } from './components/TomosGrid';
import { BonusesGrid } from './components/BonusesGrid';
import { PricingSection } from './components/PricingSection';
import { EliteFeatures } from './components/EliteFeatures';
import { ComparisonTable } from './components/ComparisonTable';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { initMetaPixel } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-white font-body selection:bg-brand-blue selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <QuickTestimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <SystemIntro data-id="element-4" />
      <TomosGrid data-id="element-5" />
      <BonusesGrid data-id="element-6" />
      <PricingSection data-id="element-7" />
      <EliteFeatures data-id="element-8" />
      <ComparisonTable data-id="element-9" />
      <ExtendedTestimonials data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
      <PurchasePopup data-id="element-15" />
    </div>;
}